import React, { useState, useEffect } from "react";

const MessageModal = ({ message, duration = 2000 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const timer = setTimeout(() => {
      setIsVisible(false);
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [duration]);

  return (
    <div
      className={`fixed inset-x-0 bottom-20 flex items-center justify-center z-10 ${
        isVisible ? "" : "hidden"
      }`}
    >
      <div className="bg-gray-600 p-2 rounded shadow">
        <p className="text-xs text-white text-center">{message}</p>
      </div>
    </div>
  );
};

export default MessageModal;
